import { useEffect, useRef } from "react";
import { Button, ButtonGroup, Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";

import { useFormikContext } from "formik";

import { InputLabel } from "../../../utils/Common";

import { useScheduleTypes } from "../../../contexts/ScheduleTypes";

const ScheduleType = () => {
  const { errors, values, setFieldValue } = useFormikContext();

  const { setAppointmentType } = useScheduleTypes();

  let { appointment_type, appointment_id } = values

  const handleChange = (e, val) => {
    setFieldValue('appointment_type', val);
  }

  useEffect(() => {
    setAppointmentType(appointment_type);
  }, [appointment_type])

  return (
    <Grid size={{xs: 12, lg: 6}}>
      <InputLabel>Appointment Type</InputLabel>
      <ToggleButtonGroup
        size="small"
        color="secondary"
        fullWidth
        value={appointment_type}
        exclusive
        disabled={!!appointment_id}
        onChange={handleChange}
      >
        <ToggleButton value="customer">Customer</ToggleButton>
        <ToggleButton value="personal_block">Personal Event</ToggleButton>
        <ToggleButton value="block">Public Block</ToggleButton>
      </ToggleButtonGroup>
    </Grid>    
  );
};

export default ScheduleType;